import React from 'react';
import { useQuery } from '@tanstack/react-query';
import { getAdminStats } from '../../api/admin';
import { LoadingScreen } from '../../components/LoadingScreen';

export const AdminDashboard: React.FC = () => {
  const { data: stats, isLoading } = useQuery({
    queryKey: ['admin-stats'],
    queryFn: getAdminStats,
  });

  if (isLoading) return <LoadingScreen message="Loading admin dashboard..." />;

  return (
    <div style={{ maxWidth: 800, margin: '0 auto', padding: 24, fontFamily: 'Arial, sans-serif' }}>
      <h1 style={{ fontSize: 28, marginBottom: 24 }}>Admin Dashboard</h1>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 16, marginBottom: 32 }}>
        <div style={{ padding: 20, backgroundColor: '#e3f2fd', borderRadius: 12, textAlign: 'center' }}>
          <div style={{ fontSize: 36, fontWeight: 700, color: '#1565c0' }}>{stats?.patients ?? 0}</div>
          <div style={{ fontSize: 16, color: '#666', marginTop: 4 }}>Patients</div>
        </div>
        <div style={{ padding: 20, backgroundColor: '#e8f5e9', borderRadius: 12, textAlign: 'center' }}>
          <div style={{ fontSize: 36, fontWeight: 700, color: '#2e7d32' }}>{stats?.users ?? 0}</div>
          <div style={{ fontSize: 16, color: '#666', marginTop: 4 }}>Users</div>
        </div>
        <div style={{ padding: 20, backgroundColor: '#fff3e0', borderRadius: 12, textAlign: 'center' }}>
          <div style={{ fontSize: 36, fontWeight: 700, color: '#e65100' }}>{stats?.visits_today ?? 0}</div>
          <div style={{ fontSize: 16, color: '#666', marginTop: 4 }}>Visits Today</div>
        </div>
      </div>
      <section>
        <h2 style={{ fontSize: 20, marginBottom: 12 }}>Quick Links</h2>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
          <a href="/patient" style={{ padding: 12, backgroundColor: '#f5f5f5', borderRadius: 8, textDecoration: 'none', color: '#333' }}>Patient Display</a>
          <a href="/carer" style={{ padding: 12, backgroundColor: '#f5f5f5', borderRadius: 8, textDecoration: 'none', color: '#333' }}>Carer Login</a>
          <a href="/family" style={{ padding: 12, backgroundColor: '#f5f5f5', borderRadius: 8, textDecoration: 'none', color: '#333' }}>Family Login</a>
          <a href="/faq" style={{ padding: 12, backgroundColor: '#f5f5f5', borderRadius: 8, textDecoration: 'none', color: '#333' }}>FAQ</a>
        </div>
      </section>
    </div>
  );
};